"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivationOrigin = exports.CancelOrigin = exports.PaymentStatus = exports.SubscriptionDetailType = void 0;
/** Define los tipos posibles de detalle de suscripción. */
exports.SubscriptionDetailType = {
    BASIC: "basic",
    PARENT: "parent",
    CHILD: "child",
};
/** Define los posibles estados de pago de una suscripción. */
exports.PaymentStatus = {
    APPROVED: "approved",
    REJECTED: "rejected",
    USER_CANCEL: "user_cancel",
    PENDING: "pending",
    AUTHORIZED: "authorized",
    REFUNDED: "refunded",
    CANCELLED: "cancelled",
    CHARGED_BACK: "charged_back",
    IN_PROCESS: "in_process",
    DELETED: "deleted",
    TRIAL: "trial",
};
/** Define los posibles orígenes de cancelación de una suscripción. */
exports.CancelOrigin = {
    PORTAL: "portal",
    USER: "user",
    MERCADOPAGO: "mercadopago",
};
/** Define los posibles orígenes de activación de una suscripción. */
exports.ActivationOrigin = {
    USER_MANUAL: "user_manual",
    ACTIVATION_BY_RETURN: "activation_by_return_to_MP_app",
    CALLBACK_ACTIVATION: "callback_activation",
};
